import React, { useContext, useEffect, useState } from 'react';
import { Box, Card, CardActions, Grid, Switch, } from '@mui/material';
import CustomButton from '../common/CustomButton';
import CustomTextField from '../common/CustomTextField';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomAutocomplete from '../common/CustomAutoComplete';
import { SaveRounded } from '@mui/icons-material';
import { Formik, Form } from 'formik';
import { GET_COMPANY, UPDATE_COMPANY } from '../../services/apiRoutes';
import { genericGet } from '../../services/apiServices';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import MessageBox from '../common/CustomMessageBox';
import CustomMaster from '../common/CustomMaster';
import { useLocation } from "react-router-dom";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from '../../services/CommonServices';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setDateFormat, setLanguageValue } from "../../constants/commonSlice";



const SystemCompany = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const selectedDateFormat = useSelector((state) => state.common.selectedDateFormat);
    const [companies, setCompanies] = useState([]);
    const [companyId, setCompanyId] = useState(null);
    const { token } = useContext(AuthContext);
    const [permission, setPermissions] = useState()
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])
    const fetchCompanies = async () => {
        try {
            const response = await genericGet({ url: GET_COMPANY });
            const companyData = response?.data?.companies || [];
            const defaultCompanies = companyData.filter((company) => company.isDefault);

            const defaultCompany = defaultCompanies[0] || null;
            const getCompanyId = defaultCompany?.companyId || null;
            setCompanies(defaultCompanies);
            setCompanyId(getCompanyId);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    useEffect(() => {
        fetchCompanies();
    }, [token]);

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const accessToken = sessionStorage.getItem('accessToken');
            const response = await axios.put(UPDATE_COMPANY(companyId), values, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: response.data.message || "updated successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchCompanies();
                },);
            } else {
                setMessage({
                    open: true,
                    text: 'Something went wrong',
                    type: 'error',
                });
            }
        } catch (error) {
            setMessage({
                open: true,
                text: 'Something went wrong',
                type: 'error',
            });
        } finally {
            setSubmitting(false);
        }
    };
    const handleLanguageChange = (event, newValue, setFieldValue) => {
        if (newValue?.value) {
            i18n.changeLanguage(newValue.value);
            setFieldValue("languageId", newValue.value);
            dispatch(setLanguageValue(newValue.value));
        }
    };


    const StyledButton = ({ isActive, onClick, children, activeColor, deactiveColor, style = {},
    }) => (
        <button
            type="submit"
            onClick={onClick}
            style={{
                ...style,
                backgroundColor: isActive ? activeColor : deactiveColor,
                color: '#fff',
                border: 'none',
                padding: '8px 16px',
                cursor: 'pointer',
                textTransform: 'capitalize',
            }}
        >
            {children}
        </button>
    );
    const defaultView = 'systemCompany';

    const mainContent = (
        <>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <Box >
                <Formik
                    initialValues={{
                        companyName: companies[0]?.companyName || '',
                        email: companies[0]?.email || '',
                        userId: companies[0]?.userId || '',
                        dateFormatId: String(companies[0]?.dateFormatId || '1'),
                        languageId: companies[0]?.languageId || 'en',
                        impShipmentId: companies[0]?.impShipmentId.toString() || '0',
                        expShipmentId: companies[0]?.expShipmentId.toString() || '0',

                        purchasePrefix: companies[0]?.purchasePrefix || '',
                        purchaseSuffix: companies[0]?.purchaseSuffix || '',
                        purchasePrefixActivity: companies[0]?.purchasePrefixActivity.toString() || '0',
                        purchaseSuffixActivity: companies[0]?.purchaseSuffixActivity.toString() || '0',
                        financialYearStart: companies[0]?.financialYearStart || '',
                        financialYearEnd: companies[0]?.financialYearEnd || '',

                        expSalesPrefix: companies[0]?.expSalesPrefix || '',
                        expSalesSuffix: companies[0]?.expSalesSuffix || '',
                        expSalesPrefixActivity: companies[0]?.expSalesPrefixActivity.toString() || '0',
                        expSalesSuffixActivity: companies[0]?.expSalesSuffixActivity.toString() || '0',

                        expProformaPrefix: companies[0]?.expProformaPrefix || '',
                        expProformaSuffix: companies[0]?.expProformaSuffix || '',
                        expProformaPrefixActivity: companies[0]?.expProformaPrefixActivity.toString() || '0',
                        expProformaSuffixActivity: companies[0]?.expProformaSuffixActivity.toString() || '0',

                        expContractPrefix: companies[0]?.expContractPrefix || '',
                        expContractSuffix: companies[0]?.expContractSuffix || '',
                        expContractPrefixActivity: companies[0]?.expContractPrefixActivity.toString() || '0',
                        expContractSuffixActivity: companies[0]?.expContractSuffixActivity.toString() || '0',

                        expCommercialPrefix: companies[0]?.expCommercialPrefix || '',
                        expCommercialSuffix: companies[0]?.expCommercialSuffix || '',
                        expCommercialPrefixActivity: companies[0]?.expCommercialPrefixActivity.toString() || '0',
                        expCommercialSuffixActivity: companies[0]?.expCommercialSuffixActivity.toString() || '0',
                    }}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
                        <Form>

                            <div>
                                <Accordion style={{ boxShadow: 'none' }} sx={{ border: '1px solid #ccc', borderRadius: '4px' }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" sx={{ fontWeight: "600", fontSize: "14px" }}>
                                        {t("Shipment ID Setting")}
                                    </AccordionSummary>
                                    <AccordionDetails style={{ marginTop: "-10px" }} >
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <span>{t("Import Shipment Id Manual")}</span>
                                                <Switch
                                                    checked={values.impShipmentId === '1'}
                                                    onChange={() => setFieldValue('impShipmentId', values.impShipmentId === '1' ? '0' : '1')}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <span>{t("Export Shipment Id Manual")}</span>
                                                <Switch
                                                    checked={values.expShipmentId === '1'}
                                                    onChange={() => setFieldValue('expShipmentId', values.expShipmentId === '1' ? '0' : '1')}
                                                />
                                            </Grid>
                                        </Grid>

                                    </AccordionDetails>
                                </Accordion>
                                <Accordion style={{ boxShadow: 'none', marginTop: "5px" }} sx={{ border: '1px solid #ccc', borderRadius: '4px' }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" sx={{ fontWeight: "600", fontSize: "14px" }}>
                                        {t("Import Shipment Prefix and suffix Setting")}
                                    </AccordionSummary>
                                    <AccordionDetails style={{ marginTop: "-10px" }} >
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4}>
                                                {t("Purchase Order")}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                                                    <Box>{t("Prefix")}</Box>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingTop: "20px" }}>
                                                    <Box>{t("Suffix")}</Box>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter Prefix"
                                                                name="purchasePrefix"
                                                                value={values.purchasePrefix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.purchasePrefixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'purchasePrefixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.purchasePrefixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'purchasePrefixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter Suffix"
                                                                name="purchaseSuffix"
                                                                value={values.purchaseSuffix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.purchaseSuffixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'purchaseSuffixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.purchaseSuffixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'purchaseSuffixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion style={{ boxShadow: 'none', marginTop: "5px" }} sx={{ border: '1px solid #ccc', borderRadius: '4px' }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" sx={{ fontWeight: "600", fontSize: "14px" }}>
                                        {t("Export Shipment Prefix and suffix Setting")}
                                    </AccordionSummary>
                                    <AccordionDetails style={{ marginTop: "-10px" }} >
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4}>
                                                {t("Sales Order")}
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                                                    <Box>{t("Prefix")}</Box>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingTop: "20px" }}>
                                                    <Box>{t("Suffix")}</Box>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter Prefix"
                                                                name="expSalesPrefix"
                                                                value={values.expSalesPrefix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.expSalesPrefixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'expSalesPrefixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.expSalesPrefixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'expSalesPrefixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter Suffix"
                                                                name="expSalesSuffix"
                                                                value={values.expSalesSuffix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.expSalesSuffixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'expSalesSuffixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.expSalesSuffixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'expSalesSuffixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={4}>
                                                <div>{t("Proforma Invoice")}</div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                                                    <Box>{t("Prefix")}</Box>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingTop: "20px" }}>
                                                    <Box>{t("Suffix")}</Box>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter Prefix"
                                                                name="expProformaPrefix"
                                                                value={values.expProformaPrefix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.expProformaPrefixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'expProformaPrefixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                Yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.expProformaPrefixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'expProformaPrefixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter Suffix"
                                                                name="expProformaSuffix"
                                                                value={values.expProformaSuffix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.expProformaSuffixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'expProformaSuffixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                Yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.expProformaSuffixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'expProformaSuffixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div>{t("Commercial Invoice")}</div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
                                                    <Box>{t("Prefix")}</Box>
                                                </div>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px', paddingTop: "20px" }}>
                                                    <Box>{t("Suffix")}</Box>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter  Prefix"
                                                                name="expCommercialPrefix"
                                                                value={values.expCommercialPrefix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.expCommercialPrefixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'expCommercialPrefixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                Yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.expCommercialPrefixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'expCommercialPrefixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div style={styles.container}>
                                                        <Box>
                                                            <CustomTextField
                                                                placeholder="Enter  Suffix"
                                                                name="expCommercialSuffix"
                                                                value={values.expCommercialSuffix}
                                                                onChange={handleChange}
                                                            />
                                                        </Box>
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                paddingLeft: "10px"
                                                            }}
                                                        >
                                                            <StyledButton
                                                                isActive={values.expCommercialSuffixActivity === '1'}
                                                                onClick={() => handleChange({ target: { name: 'expCommercialSuffixActivity', value: '1' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "4px 0 0 4px" }}
                                                            >
                                                                Yes
                                                            </StyledButton>
                                                            <StyledButton
                                                                isActive={values.expCommercialSuffixActivity === '0'}
                                                                onClick={() => handleChange({ target: { name: 'expCommercialSuffixActivity', value: '0' } })}
                                                                activeColor="#007BFF"
                                                                deactiveColor="#D50000"
                                                                style={{ borderRadius: "0px 4px 4px 0px" }}
                                                            >
                                                                No
                                                            </StyledButton>
                                                        </Box>
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                            <div>
                                <Card style={{ boxShadow: 'none', marginTop: "5px" }} sx={{ border: '1px solid #ccc', borderRadius: '4px', paddingLeft: "12px", paddingRight: "12px" }}>
                                    <Grid container spacing={2} style={{ marginTop: "3px", marginBottom: "13px" }}>
                                        <Grid item xs={12} md={6}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <label style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{t("Financial Year")}</label>
                                                <CustomTextField
                                                    name="financialYearStart"
                                                    required={true}
                                                    type="date"
                                                    value={values.financialYearStart}
                                                    onChange={handleChange}
                                                    placeholder="Enter financialYearStart Date"
                                                    error={touched.financialYearStart && !!errors.financialYearStart}
                                                    helperText={touched.financialYearStart && errors.financialYearStart}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                                <span>-</span>
                                                <CustomTextField
                                                    name="financialYearEnd"
                                                    required={true}
                                                    type="date"
                                                    value={values.financialYearEnd}
                                                    onChange={handleChange}
                                                    placeholder="Enter financialYearEnd Date"
                                                    error={touched.financialYearEnd && !!errors.financialYearEnd}
                                                    helperText={touched.financialYearEnd && errors.financialYearEnd}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <label style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>  {t("Date Format")}  </label>

                                                <CustomAutocomplete
                                                    options={dateFormats}
                                                    required
                                                    getOptionLabel={(option) => option.title}
                                                    placeholder="Select Date"
                                                    style={{ width: "200px" }}
                                                    value={dateFormats.find((item) => item.value === values.dateFormatId)}
                                                    onChange={(e, newValue) => {
                                                        const selectedValue = newValue?.value || '';
                                                        dispatch(setDateFormat(selectedValue));
                                                        setFieldValue('dateFormatId', selectedValue);
                                                    }}
                                                />

                                            </div>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <label style={{ whiteSpace: 'nowrap', fontWeight: 500 }}>{t("Language")}</label>
                                                <CustomAutocomplete
                                                    options={internationalLanguages}
                                                    required
                                                    getOptionLabel={(option) => option.title}
                                                    placeholder="Select Language"
                                                    style={{ width: "200px" }}
                                                    value={internationalLanguages.find(
                                                        (item) => item.value === values.languageId
                                                    )}
                                                    onChange={(e, newValue) => handleLanguageChange(e, newValue, setFieldValue)}
                                                />

                                            </div>
                                        </Grid>
                                    </Grid>
                                </Card>
                                <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <CustomButton
                                        startIcon={<SaveRounded />}
                                        title='Save'
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting}
                                    />
                                </CardActions>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Box>
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (

        <>
            <CustomMaster
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)}
            />
            {!permission?.view && <AccessDenied />}
        </>
    );
};

export default SystemCompany;

const dateFormats = [
    { value: '1', title: 'DD/MM/YYYY' },
    { value: '2', title: 'MM/DD/YYYY' },
    { value: '3', title: 'YYYY-MM-DD' },
    { value: '4', title: '28 June 2025' },
    { value: '5', title: 'Saturday, 28 Jun 2025' },
    { value: '6', title: '28 Jun 25' },
];

const internationalLanguages = [
    { value: 'en', title: 'English', },
    { value: 'hi', title: 'हिंदी', },
    { value: 'zh', title: '中文', },
];

const styles = {
    heading: {
        marginBottom: '1px',
        fontSize: '14px'
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1px'
    },
    details: {
        flex: 1,
        marginRight: '1px'
    }
};
